import { render, staticRenderFns } from "./personnelinfo.vue?vue&type=template&id=3cb43a60&scoped=true"
import script from "./personnelinfo.vue?vue&type=script&lang=js"
export * from "./personnelinfo.vue?vue&type=script&lang=js"
import style0 from "./personnelinfo.vue?vue&type=style&index=0&id=3cb43a60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb43a60",
  null
  
)

export default component.exports